import CmpSliderHorizontalOptions from "./CmpSliderHorizontalOptions";

export default CmpSliderHorizontalOptions;